import reactEnv from '@beam-australia/react-env';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    __ENV: Record<string, string>;
  }
}

/**
 * When the app runs with Cypress, reactEnv function is undefined initially.
 * This is a fix to prevent Cypress from crashing.
 */
export const env = (key: string): string | undefined => {
  if (reactEnv) {
    return reactEnv(key);
  }

  const safeKey = `REACT_APP_${key}`;
  if (typeof window !== 'undefined') {
    return window.__ENV[safeKey];
  } else {
    return process.env[safeKey];
  }
};

export const enableMockServer = env('MOCK_SERVER') === 'true';

type ReleaseEnv = 'staging' | 'preprod' | 'prod';
export const releaseEnv: ReleaseEnv = (env('ALGOAN_ENV') as ReleaseEnv | undefined) ?? 'preprod';

export const apiUrl = env('API_URL') ?? 'https://api.preprod.algoan.com';

export const consoleUrl = env('CONSOLE_URL') ?? 'https://console.preprod.algoan.com';

export const adminUrl = env('ADMIN_URL') ?? 'https://admin.preprod.algoan.com';

export const showcaseUrl = env('SHOWCASE_URL') ?? 'https://showcase.preprod.algoan.com';

export const tgglApiKey = env('TGGL_API_KEY') ?? 'JMj06n-a5ivHL9geZZtGeIzzz-U8iu8CfbrKm_CvzbY';

export const commitSha = env('COMMIT_SHA');
